import { useForumDateFormatSource } from "components/ForumDateFormatProvider";
import { FC, useMemo } from "react";
import { getForumDateDisplayFormat, toWallClockMoment } from "utils/dateUtils";
import moment from "moment";

interface DateRendererProps {
  date?: object | string | null;
  hideDate?: boolean;
  showTime?: boolean;
  wallClock?: boolean;
}
const DateRenderer: FC<DateRendererProps> = ({
  date,
  hideDate = false,
  showTime = false,
  wallClock = false,
}: DateRendererProps) => {
  const forumDateFormatSource = useForumDateFormatSource();
  const format = useMemo(() => {
    return getForumDateDisplayFormat(forumDateFormatSource, { hideDate, showTime });
  }, [forumDateFormatSource, showTime, hideDate]);

  const momentDate = wallClock ? toWallClockMoment(date) : moment(date);
  return <>{momentDate.format(format)}</>;
};

export default DateRenderer;
